import { useLoggedInUser } from 'app/auth/useLoggedInUser';
import { PageClaim } from 'gen/ApiClient';
import { useMemo } from 'react';
import { calculateHasAccess } from './calculateHasAccess';

export const useUserHasPageClaimOrDefault = (pageClaim: PageClaim | undefined): boolean => {
	const user = useLoggedInUser();
	return useMemo(() => (pageClaim === undefined ? true : calculateHasAccess(pageClaim, user)), [pageClaim, user]);
};
